var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "new_content" }, [
      _c("div", { staticClass: "new_jpkc_erji" }, [
        _c("div", { staticClass: "new_webposition" }, [
          _vm._v("\n        账号设置"),
          _c("span", { staticClass: "nje_jiange" }, [_vm._v(">")]),
          _vm._v(" "),
          _vm.baseVisible == true
            ? _c("div", { staticClass: "nje_last" }, [_vm._v("基本信息")])
            : _vm._e(),
          _vm._v(" "),
          _vm.phoneVisible == true
            ? _c("div", { staticClass: "nje_last" }, [_vm._v("验证手机号")])
            : _vm._e(),
          _vm._v(" "),
          _vm.cellVisible == true
            ? _c("div", { staticClass: "nje_last" }, [_vm._v("修改手机号")])
            : _vm._e(),
          _vm._v(" "),
          _vm.pwdVisible == true
            ? _c("div", { staticClass: "nje_last" }, [_vm._v("修改密码")])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "new_yxdt" }, [
          _c("div", { staticClass: "new_yxdt_tab" }, [
            _c("ul", { attrs: { id: "new_yxdt_tab_all" } }, [
              _c("li", [
                _c(
                  "a",
                  {
                    class: { new_yxdt_tab_sel: _vm.baseVisible },
                    attrs: { id: "basicUpdate", href: "javascript:" },
                    on: {
                      click: function($event) {
                        return _vm.changeTabs(1)
                      }
                    }
                  },
                  [_vm._v("基本信息")]
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c(
                  "a",
                  {
                    class: { new_yxdt_tab_sel: _vm.phoneVisible },
                    attrs: { id: "mobileUpdate", href: "javascript:" },
                    on: {
                      click: function($event) {
                        return _vm.changeTabs(2)
                      }
                    }
                  },
                  [_vm._v("验证手机号")]
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c(
                  "a",
                  {
                    class: { new_yxdt_tab_sel: _vm.cellVisible },
                    attrs: { id: "mobileUpdate", href: "javascript:" },
                    on: {
                      click: function($event) {
                        return _vm.changeTabs(5)
                      }
                    }
                  },
                  [_vm._v("修改手机号")]
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c(
                  "a",
                  {
                    class: { new_yxdt_tab_sel: _vm.pwdVisible },
                    attrs: { id: "passwordUdate", href: "javascript:" },
                    on: {
                      click: function($event) {
                        return _vm.changeTabs(4)
                      }
                    }
                  },
                  [_vm._v("修改密码")]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.baseVisible == true,
                  expression: "baseVisible == true"
                }
              ],
              staticClass: "new_jpkc_list",
              staticStyle: {
                "padding-left": "15px",
                "border-left": "1px #CCCCCC solid",
                position: "relative"
              }
            },
            [
              _c(
                "div",
                { staticClass: "new_upload_head" },
                [
                  _c(
                    "el-form",
                    { ref: "form" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { prop: "imageUrl" },
                          model: {
                            value: _vm.form.imageUrl,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "imageUrl", $$v)
                            },
                            expression: "form.imageUrl"
                          }
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                action: _vm.uploadUrl,
                                "before-upload": _vm.beforeAvatarUpload,
                                "on-success": _vm.handleAvatarSuccess
                              }
                            },
                            [
                              _vm.form.imageUrl
                                ? _c("img", {
                                    staticClass: "avatar",
                                    attrs: { src: _vm.form.imageUrl, alt: "" }
                                  })
                                : _c("img", {
                                    staticClass: "avatar",
                                    attrs: {
                                      alt: "",
                                      src:
                                        "https://source.yiboshi.com/user/GetUserImage.jpeg"
                                    }
                                  })
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "new_upload_head_text" }, [
                    _vm._v("点击图片修改头像")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "new_userInfo_box" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: {
                        model: _vm.form,
                        rules: _vm.rules,
                        "label-width": "100px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "真实姓名", prop: "realname" } },
                        [
                          _c("el-input", {
                            staticClass: "baseInput",
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.realname,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "realname", $$v)
                              },
                              expression: "form.realname"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户名", prop: "userName" } },
                        [
                          _c("el-input", {
                            staticClass: "baseInput",
                            model: {
                              value: _vm.form.userName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "userName", $$v)
                              },
                              expression: "form.userName"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "性别", prop: "sex" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.sex,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "sex", $$v)
                                },
                                expression: "form.sex"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("男")
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("女")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "证件类型", prop: "cardType" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                disabled: "",
                                placeholder: "请选择证件类型"
                              },
                              model: {
                                value: _vm.form.cardType,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "cardType", $$v)
                                },
                                expression: "form.cardType"
                              }
                            },
                            _vm._l(_vm.cardTypeOptions, function(item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.value, value: item.key }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "证件号", prop: "cardNumber" } },
                        [
                          _c("el-input", {
                            staticClass: "baseInput",
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.cardNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cardNumber", $$v)
                              },
                              expression: "form.cardNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "所在单位", prop: "companyName" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "350px" },
                              attrs: {
                                disabled: _vm.isAlterOrg === 1,
                                loading: _vm.compLoading,
                                "no-data-text": _vm.compPrompt,
                                "remote-method": _vm.remoteSearchComp,
                                filterable: "",
                                placeholder: "请输入关键词",
                                remote: ""
                              },
                              on: { change: _vm.orgIdChange },
                              model: {
                                value: _vm.form.companyName,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "companyName", $$v)
                                },
                                expression: "form.companyName"
                              }
                            },
                            _vm._l(_vm.compOptions, function(item) {
                              return _c(
                                "el-option",
                                {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { float: "left" } },
                                    [_vm._v(_vm._s(item.name))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        float: "right",
                                        color: "#8492A6",
                                        "font-size": "13px",
                                        "margin-left": "10px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatRegion(
                                            item.province,
                                            item.city,
                                            item.county,
                                            item.rural
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "所在科室", prop: "department" } },
                        [
                          _c("el-autocomplete", {
                            attrs: {
                              "fetch-suggestions": _vm.searchDepartment,
                              placeholder: "请输入内容"
                            },
                            on: {
                              blur: _vm.departmentBlur,
                              select: _vm.departmentSelect
                            },
                            model: {
                              value: _vm.form.department,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "department", $$v)
                              },
                              expression: "form.department"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "人员类别", prop: "personType" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择人员类别" },
                              on: { change: _vm.changePersonType },
                              model: {
                                value: _vm.form.personType,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "personType", $$v)
                                },
                                expression: "form.personType"
                              }
                            },
                            _vm._l(_vm.personTypeOptions, function(item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.value, value: item.key }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "乡村医生", prop: "countryDoctor" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.form.countryDoctor,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "countryDoctor", $$v)
                                },
                                expression: "form.countryDoctor"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { value: 1, label: "是" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: 0, label: "否" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { labelWidth: "0", prop: "specialty" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "专业一",
                                    prop: "specialtyId1"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { placeholder: "请选择专业1" },
                                      on: { change: _vm.changeSpecialtyId1 },
                                      model: {
                                        value: _vm.form.specialtyId1,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "specialtyId1",
                                            $$v
                                          )
                                        },
                                        expression: "form.specialtyId1"
                                      }
                                    },
                                    _vm._l(_vm.specialtyId1Options, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          label: item.value,
                                          value: item.key
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "专业二",
                                    labelWidth: "100",
                                    prop: "specialtyId2"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { placeholder: "请选择专业2" },
                                      model: {
                                        value: _vm.form.specialtyId2,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "specialtyId2",
                                            $$v
                                          )
                                        },
                                        expression: "form.specialtyId2"
                                      }
                                    },
                                    _vm._l(_vm.specialtyId2Options, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          label: item.value,
                                          value: item.key
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { labelWidth: "0" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "职称", prop: "title" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { placeholder: "请选择职称" },
                                      model: {
                                        value: _vm.form.title,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "title", $$v)
                                        },
                                        expression: "form.title"
                                      }
                                    },
                                    _vm._l(_vm.titleOptions, function(item) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          label: item.value,
                                          value: item.key
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "获取职称日期",
                                    labelWidth: "100",
                                    prop: "title"
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      id: "title",
                                      placeholder: "请选择获取职称日期",
                                      type: "date"
                                    },
                                    model: {
                                      value: _vm.form.getTitleDate,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "getTitleDate", $$v)
                                      },
                                      expression: "form.getTitleDate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { labelWidth: "0" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "执业类别",
                                    prop: "occupationType"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { placeholder: "请选择执业类别" },
                                      model: {
                                        value: _vm.form.occupationType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "occupationType",
                                            $$v
                                          )
                                        },
                                        expression: "form.occupationType"
                                      }
                                    },
                                    _vm._l(_vm.occupationTypeOptions, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          label: item.value,
                                          value: item.key
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "执业资格",
                                    prop: "practicingRequirements"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { placeholder: "请选择执业资格" },
                                      model: {
                                        value: _vm.form.practicingRequirements,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "practicingRequirements",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.practicingRequirements"
                                      }
                                    },
                                    _vm._l(_vm.requirementsOptions, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          label: item.value,
                                          value: item.key
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "资格证书编号",
                            prop: "certificateNumber"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "baseInput",
                            model: {
                              value: _vm.form.certificateNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "certificateNumber", $$v)
                              },
                              expression: "form.certificateNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "执业证书编号",
                            prop: "practisingCertificate"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "baseInput",
                            model: {
                              value: _vm.form.practisingCertificate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "practisingCertificate", $$v)
                              },
                              expression: "form.practisingCertificate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { labelWidth: "0" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "学历", prop: "education" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { placeholder: "请选择学历" },
                                      model: {
                                        value: _vm.form.education,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "education", $$v)
                                        },
                                        expression: "form.education"
                                      }
                                    },
                                    _vm._l(_vm.educationOptions, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          label: item.value,
                                          value: item.key
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "院内职务", prop: "duty" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { placeholder: "请选择院内职务" },
                                      model: {
                                        value: _vm.form.duty,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "duty", $$v)
                                        },
                                        expression: "form.duty"
                                      }
                                    },
                                    _vm._l(_vm.dutyOptions, function(item) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          label: item.value,
                                          value: item.key
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { labelWidth: "0" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "出生日期", prop: "birthday" }
                                },
                                [
                                  _c("el-date-picker", {
                                    attrs: { id: "birthday", type: "date" },
                                    model: {
                                      value: _vm.form.birthday,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "birthday", $$v)
                                      },
                                      expression: "form.birthday"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "民族", prop: "nation" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        filterable: "",
                                        placeholder: "请选择民族"
                                      },
                                      model: {
                                        value: _vm.form.nation,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "nation", $$v)
                                        },
                                        expression: "form.nation"
                                      }
                                    },
                                    _vm._l(_vm.nationOptions, function(item) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          label: item.value,
                                          value: item.key
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "政治面貌", prop: "politicsStatus" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择政治面貌" },
                              model: {
                                value: _vm.form.politicsStatus,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "politicsStatus", $$v)
                                },
                                expression: "form.politicsStatus"
                              }
                            },
                            _vm._l(_vm.politicsStatusOptiosn, function(item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.value, value: item.key }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { staticStyle: { "text-align": "center" } },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading.fullscreen.lock",
                                  value: _vm.fullscreenLoading,
                                  expression: "fullscreenLoading",
                                  modifiers: { fullscreen: true, lock: true }
                                }
                              ],
                              staticStyle: {
                                width: "40%",
                                "margin-top": "20px"
                              },
                              attrs: { type: "primary" },
                              on: { click: _vm.editUserInfo }
                            },
                            [_vm._v("保      存\n                ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.phoneVisible == true,
                  expression: "phoneVisible == true"
                }
              ],
              staticClass: "new_jpkc_list",
              staticStyle: {
                "padding-left": "15px",
                "border-left": "1px #CCCCCC solid"
              }
            },
            [
              _c(
                "div",
                { staticClass: "new_userInfo_box" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "mobileForm",
                      attrs: {
                        model: _vm.mobileForm,
                        rules: _vm.mobileRules,
                        "label-width": "100px"
                      }
                    },
                    [
                      _vm.oldMobileExist == true
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "手机号码", prop: "oldMobile" } },
                            [
                              _c("el-input", {
                                staticClass: "baseInput",
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.mobileForm.oldMobile,
                                  callback: function($$v) {
                                    _vm.$set(_vm.mobileForm, "oldMobile", $$v)
                                  },
                                  expression: "mobileForm.oldMobile"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "el-link",
                                {
                                  attrs: { underline: false, type: "success" }
                                },
                                [_vm._v("手机号已验证")]
                              )
                            ],
                            1
                          )
                        : _c(
                            "el-form-item",
                            { attrs: { label: "手机号码", prop: "newMobile" } },
                            [
                              _c("el-input", {
                                staticClass: "baseInput",
                                attrs: { placeholder: "请输入11位手机号码" },
                                model: {
                                  value: _vm.mobileForm.newMobile,
                                  callback: function($$v) {
                                    _vm.$set(_vm.mobileForm, "newMobile", $$v)
                                  },
                                  expression: "mobileForm.newMobile"
                                }
                              })
                            ],
                            1
                          ),
                      _vm._v(" "),
                      !_vm.oldMobileExist
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "验证码", prop: "mobileCode" } },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.verifyShow,
                                      expression: "verifyShow"
                                    }
                                  ],
                                  staticClass: "verifyMain"
                                },
                                [
                                  _c("Verify", {
                                    ref: "verify",
                                    attrs: {
                                      captchaType: "blockPuzzle",
                                      imgSize: {
                                        width: "240px",
                                        height: "120px"
                                      },
                                      mode: "fixed"
                                    },
                                    on: { success: _vm.success }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.verifyOK,
                                          expression: "verifyOK"
                                        }
                                      ],
                                      staticClass: "verifyOK"
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-success",
                                        staticStyle: {
                                          color: "#67C23A",
                                          "margin-left": "12px",
                                          "margin-right": "8px"
                                        }
                                      }),
                                      _vm._v(
                                        "\n                    验证通过\n                  "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("el-input", {
                                staticClass: "baseInput",
                                staticStyle: { width: "280px" },
                                attrs: {
                                  disabled: _vm.oldMobileExist,
                                  placeholder: "请输入短信验证码"
                                },
                                model: {
                                  value: _vm.mobileForm.mobileCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.mobileForm, "mobileCode", $$v)
                                  },
                                  expression: "mobileForm.mobileCode"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    "margin-left": "10px",
                                    padding: "9px 9px"
                                  },
                                  attrs: {
                                    disabled:
                                      _vm.oldMobileExist ||
                                      _vm.sendSmsButtonDisabled,
                                    size: "small",
                                    type: "primary"
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.sendSmsMethod(
                                        "mobileForm",
                                        "newMobile",
                                        1
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.sendSmsButtonText) +
                                      "\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.oldMobileExist
                        ? _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { width: "30%" },
                                  attrs: {
                                    disabled:
                                      _vm.oldMobileExist || _vm.verifyOkBtn,
                                    type: "primary"
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.editUserMobile("mobileForm", 1)
                                    }
                                  }
                                },
                                [_vm._v("确      定\n                ")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.cellVisible == true,
                  expression: "cellVisible == true"
                }
              ],
              staticClass: "new_jpkc_list",
              staticStyle: {
                "padding-left": "15px",
                "border-left": "1px #CCCCCC solid"
              }
            },
            [
              _c(
                "div",
                { staticClass: "step" },
                [
                  _c(
                    "el-steps",
                    {
                      staticClass: "stepdiv",
                      attrs: {
                        active: _vm.tipactive,
                        "finish-status": "success",
                        simple: ""
                      }
                    },
                    [
                      _c("el-step", { attrs: { title: "解绑原手机号" } }),
                      _vm._v(" "),
                      _c("el-step", { attrs: { title: "绑定新手机号" } }),
                      _vm._v(" "),
                      _c("el-step", { attrs: { title: "完成" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.cellactive == 1,
                      expression: "cellactive == 1"
                    }
                  ],
                  staticClass: "mobileFormEdit"
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "mobileFormEdit",
                      staticClass: "formcss",
                      attrs: {
                        model: _vm.mobileFormEdit,
                        rules: _vm.mobileRulesEdit,
                        "label-width": "100px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "self",
                          attrs: { label: "原手机号", prop: "oldMobile" }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "370px" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.mobileFormEdit.oldMobile,
                              callback: function($$v) {
                                _vm.$set(_vm.mobileFormEdit, "oldMobile", $$v)
                              },
                              expression: "mobileFormEdit.oldMobile"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#38BCD5",
                                height: "20px",
                                padding: "0px",
                                "line-height": "20px"
                              }
                            },
                            [
                              _vm._v(
                                "\n                  注：如原手机号不可使用，请联系客服400-822-2055\n                "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "验证码", prop: "mobileCode" } },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.verifyShow,
                                  expression: "verifyShow"
                                }
                              ],
                              staticClass: "verifyMain"
                            },
                            [
                              _c("Verify", {
                                ref: "verify",
                                attrs: {
                                  captchaType: "blockPuzzle",
                                  imgSize: {
                                    width: "240px",
                                    height: "120px"
                                  },
                                  mode: "fixed"
                                },
                                on: { success: _vm.success }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.verifyOK,
                                      expression: "verifyOK"
                                    }
                                  ],
                                  staticClass: "verifyOK"
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-success",
                                    staticStyle: {
                                      color: "#67C23A",
                                      "margin-left": "12px",
                                      "margin-right": "8px"
                                    }
                                  }),
                                  _vm._v(
                                    "\n                    验证通过\n                  "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-input", {
                            staticStyle: { width: "280px" },
                            attrs: { placeholder: "请输入短信验证码" },
                            model: {
                              value: _vm.mobileFormEdit.mobileCode,
                              callback: function($$v) {
                                _vm.$set(_vm.mobileFormEdit, "mobileCode", $$v)
                              },
                              expression: "mobileFormEdit.mobileCode"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                "margin-left": "10px",
                                padding: "10px 9px"
                              },
                              attrs: {
                                disabled: _vm.sendSmsButtonTextEditOldDisabled,
                                size: "small",
                                type: "primary"
                              },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.sendSmsMethod(
                                    "mobileFormEdit",
                                    "oldMobile",
                                    4
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.sendSmsButtonTextEditOld) +
                                  "\n                "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "276px" },
                              attrs: {
                                disabled: _vm.editcellnextbtnDisabled,
                                type: "primary"
                              },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.nextMobile.apply(null, arguments)
                                }
                              }
                            },
                            [_vm._v("下一步\n                ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.cellactive == 2,
                      expression: "cellactive == 2"
                    }
                  ],
                  staticClass: "mobileFormEdit"
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "mobileFormEditNew",
                      staticClass: "formcss",
                      attrs: {
                        model: _vm.mobileFormEditNew,
                        rules: _vm.mobileRulesNew,
                        "label-width": "100px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "新手机号", prop: "newMobile" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "370px" },
                            attrs: { placeholder: "请输入11位手机号码" },
                            model: {
                              value: _vm.mobileFormEditNew.newMobile,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.mobileFormEditNew,
                                  "newMobile",
                                  $$v
                                )
                              },
                              expression: "mobileFormEditNew.newMobile"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "验证码", prop: "mobileCode" } },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.verifyShow,
                                  expression: "verifyShow"
                                }
                              ],
                              staticClass: "verifyMain"
                            },
                            [
                              _c("Verify", {
                                ref: "verify",
                                attrs: {
                                  captchaType: "blockPuzzle",
                                  imgSize: {
                                    width: "240px",
                                    height: "120px"
                                  },
                                  mode: "fixed"
                                },
                                on: { success: _vm.success }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.verifyOK,
                                      expression: "verifyOK"
                                    }
                                  ],
                                  staticClass: "verifyOK"
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-success",
                                    staticStyle: {
                                      color: "#67C23A",
                                      "margin-left": "12px",
                                      "margin-right": "8px"
                                    }
                                  }),
                                  _vm._v(
                                    "\n                    验证通过\n                  "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-input", {
                            staticStyle: { width: "280px" },
                            attrs: { placeholder: "请输入短信验证码" },
                            model: {
                              value: _vm.mobileFormEditNew.mobileCode,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.mobileFormEditNew,
                                  "mobileCode",
                                  $$v
                                )
                              },
                              expression: "mobileFormEditNew.mobileCode"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                "margin-left": "10px",
                                padding: "10px 9px"
                              },
                              attrs: {
                                disabled: _vm.sendSmsButtonTextEditNewDisabled,
                                size: "small",
                                type: "primary"
                              },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.sendSmsMethod(
                                    "mobileFormEditNew",
                                    "newMobile",
                                    5
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.sendSmsButtonTextEditNew) +
                                  "\n                "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "276px" },
                              attrs: {
                                disabled: _vm.editcellokbtnDisabled,
                                type: "primary"
                              },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.editUserMobile("mobileFormEdit", 2)
                                }
                              }
                            },
                            [_vm._v("确定\n                ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.emailVisible == true,
                  expression: "emailVisible == true"
                }
              ],
              staticClass: "new_jpkc_list",
              staticStyle: {
                "padding-left": "15px",
                "border-left": "1px #CCCCCC solid"
              }
            },
            [
              _c(
                "div",
                { staticClass: "new_userInfo_box" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      ref: "emailForm",
                      attrs: {
                        model: _vm.emailForm,
                        rules: _vm.emailRules,
                        "label-width": "100px"
                      }
                    },
                    [
                      _vm.oldEmailExist == true
                        ? _c(
                            "el-form-item",
                            {
                              attrs: { label: "已验证邮箱", prop: "oldEmail" }
                            },
                            [
                              _c("el-input", {
                                staticClass: "baseInput",
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.emailForm.oldEmail,
                                  callback: function($$v) {
                                    _vm.$set(_vm.emailForm, "oldEmail", $$v)
                                  },
                                  expression: "emailForm.oldEmail"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "新邮箱", prop: "newEmail" } },
                        [
                          _c("el-input", {
                            staticClass: "baseInput",
                            model: {
                              value: _vm.emailForm.newEmail,
                              callback: function($$v) {
                                _vm.$set(_vm.emailForm, "newEmail", $$v)
                              },
                              expression: "emailForm.newEmail"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "20px" },
                              attrs: {
                                disabled: _vm.sendEmailButtonDisabled,
                                size: "small",
                                type: "primary"
                              },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.sendEmailMethod.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.sendEmailButtonText) +
                                  "\n                "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "验证码", prop: "emailCode" } },
                        [
                          _c("el-input", {
                            staticClass: "baseInput",
                            model: {
                              value: _vm.emailForm.emailCode,
                              callback: function($$v) {
                                _vm.$set(_vm.emailForm, "emailCode", $$v)
                              },
                              expression: "emailForm.emailCode"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "yz ml-20 pa",
                              attrs: {
                                href: "javascript:",
                                title:
                                  "1.电子邮件偶尔会有延时状况，请耐心等待2.尝试到垃圾邮件里找找看3.若有疑问请拨打客服电话：400-822-2055"
                              }
                            },
                            [_vm._v("\n                  没有收到验证码？")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "30%" },
                              attrs: { type: "primary" },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.editUserEmail.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [_vm._v("保      存\n                ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.pwdVisible == true,
                  expression: "pwdVisible == true"
                }
              ],
              staticClass: "new_jpkc_list",
              staticStyle: {
                "padding-left": "15px",
                "border-left": "1px #CCCCCC solid",
                width: "660px"
              }
            },
            [_vm.pwdVisible ? _c("ChangePasswordBase") : _vm._e()],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "verify_box" },
      [
        _vm.verifyShow
          ? _c("Verify", {
              ref: "verifyRef",
              attrs: {
                captchaType: "blockPuzzle",
                imgSize: { width: "240px", height: "120px" },
                mode: "pop"
              },
              on: { close: _vm.verifyClose, success: _vm.verifySuccess }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "new_reminder_txt" }, [
      _c("span", [_vm._v("!")]),
      _vm._v("在忘记密码后，可通过邮箱快速找回密码。"),
      _c("br"),
      _vm._v("如果已经更换邮箱，建议立刻更新验证。\n            ")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23c8538c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c8538c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/usercenter/EditUser.vue
// module id = null
// module chunks = 